class CookieOptionalScriptsLoader {
    constructor() {
        this.loadedScripts = new Set();
        this.optionalScripts = this.getOptionalScripts();

        if (!this.optionalScripts.length) {
            return;
        }

        this.init();
    }

    init() {
        window.addEventListener('cookieConsentReady', (event) => {
            const consent = event && event.detail ? event.detail.consent : null;
            this.loadAllowedScripts(consent);
        });

        window.addEventListener('cookieConsentUpdated', (event) => {
            const consent = event && event.detail ? event.detail.consent : null;
            this.loadAllowedScripts(consent);
        });

        this.loadAllowedScripts(this.resolveCurrentConsent());
    }

    getOptionalScripts() {
        if (!window.backendData || !window.backendData.cookieConsent) {
            return [];
        }

        const scripts = window.backendData.cookieConsent.optionalScripts;

        if (!Array.isArray(scripts)) {
            return [];
        }

        return scripts.filter((scriptConfig) => {
            return scriptConfig
                && typeof scriptConfig === 'object'
                && typeof scriptConfig.id === 'string'
                && scriptConfig.id.length > 0
                && typeof scriptConfig.category === 'string'
                && scriptConfig.category.length > 0
                && (typeof scriptConfig.src === 'string' || typeof scriptConfig.inline === 'string');
        });
    }

    loadAllowedScripts(consent) {
        if (!consent || !consent.categories) {
            return;
        }

        this.optionalScripts.forEach((scriptConfig) => {
            if (this.loadedScripts.has(scriptConfig.id)) {
                return;
            }

            if (!consent.categories[scriptConfig.category]) {
                return;
            }

            this.injectScript(scriptConfig);
            this.loadedScripts.add(scriptConfig.id);
        });
    }

    resolveCurrentConsent() {
        if (!window.CookieConsentManager) {
            return null;
        }

        const policyVersion = window.backendData
            && window.backendData.cookieConsent
            && window.backendData.cookieConsent.version
            ? window.backendData.cookieConsent.version
            : '1.0.0';
        const manager = new window.CookieConsentManager({
            storageKey: 'cookie_consent_status',
            policyVersion,
        });

        return manager.getConsent();
    }

    injectScript(scriptConfig) {
        const scriptElement = document.createElement('script');
        scriptElement.setAttribute('data-cookie-script-id', scriptConfig.id);

        if (scriptConfig.src) {
            scriptElement.src = scriptConfig.src;
        }

        if (scriptConfig.inline) {
            scriptElement.text = scriptConfig.inline;
        }

        if (scriptConfig.async === true) {
            scriptElement.async = true;
        }

        if (scriptConfig.defer === true) {
            scriptElement.defer = true;
        }

        if (scriptConfig.attributes && typeof scriptConfig.attributes === 'object') {
            Object.entries(scriptConfig.attributes).forEach(([key, value]) => {
                if (typeof value === 'string') {
                    scriptElement.setAttribute(key, value);
                }
            });
        }

        document.body.appendChild(scriptElement);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new CookieOptionalScriptsLoader();
    });
} else {
    new CookieOptionalScriptsLoader();
}
